import eastChina from '../../components/eastChina/eastChina'
import northChina from '../../components/northChina/northChina'
import southWest from '../../components/southwest/southwest'
import southChina from '../../components/southChina/southChina'
export default ({
    data() {
        return {
            currentMenu: '/globalNet/eastChina',
        }
    },
    components: { eastChina, northChina, southWest, southChina },
    created() {
        var route = this.$route.path
        this.currentMenu = route
    },
    watch:{
        //监听路由变化
        $route(to,from){
            var route = to.path
            this.currentMenu = route
        }
    },
    methods: {
        selectMenu(page){
            var route = this.$route.path
            this.currentMenu = page
            if(page != route){
                this.$router.push(page)
            }
        }
    }
})


// WEBPACK FOOTER //
// ./src/pages/globalNet/globalNet.vue.js